import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateTransform } from '@app/shared/utils/date.transform';

export function dateRangeValidator(withTime = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.get('StartDate').enabled && control.get('EndDate').enabled) {
      const value = control.value;

      if (!value?.StartDate || !value?.EndDate) {
        return { dateRangeError: true };
      }

      const startDate = new Date(value.StartDate);
      const endDate = new Date(value.EndDate);

      if (withTime) {
        // minutes
        if (DateTransform.isAfter(startDate, endDate)) {
          return { dateRangeError: true };
        }
      } else {
        // days
        if (DateTransform.isAfter(DateTransform.startOfDay(startDate), DateTransform.startOfDay(endDate))) {
          return { dateRangeError: true };
        }
      }
    }

    return null;
  };
}
